import { render, staticRenderFns } from "./ziyingShop.vue?vue&type=template&id=179c310e&scoped=true&"
import script from "./ziyingShop.vue?vue&type=script&lang=ts&"
export * from "./ziyingShop.vue?vue&type=script&lang=ts&"
import style0 from "./ziyingShop.vue?vue&type=style&index=0&id=179c310e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179c310e",
  null
  
)

export default component.exports